import styled, { css } from 'styled-components'
import { Footer as BaseFooter } from '@sketch/modules-common'
import { Link, TableComponents } from '@sketch/components'

import { DocumentGridItem, GridFocusStyles } from '../DocumentItem'

import { breakpoint } from '@sketch/global-styles'

const headerStyles = css(
  ({ theme }) => css`
    top: 54px; /* Height of the Header + the Margin */
    margin-bottom: 30px; /* stylelint-disable-line scales/space */
    /* Allows the last row to be half visible when scrolling */
    background: ${theme.colors.background.secondary.B};
    border-bottom: 1px solid ${theme.colors.border.A};
    z-index: ${theme.zIndex[2]};

    ::before {
      position: absolute;
      content: '';
      background: ${theme.colors.background.secondary.B};
      width: 100%;
      height: 100%;
      left: 0;
      bottom: 0;
      z-index: -1;

      box-sizing: content-box;
      padding-top: 40px;
    }

    ${breakpoint('sm')`
      position: sticky;
      top: 88px; /* Height of the Header + the Margin */
    `}
  `
)

export const HeaderTableCell = styled(TableComponents.TableHeaderCell)`
  ${headerStyles}
`

export const ActionTableCell = styled(TableComponents.TableHeaderCellSticky)`
  ${headerStyles};

  width: 64px;

  /* Just for hiding the text */
  background: ${({ theme }) => theme.colors.background.secondary.B};
`

export const TableWrapper = styled.div(
  ({ theme }) => css`
    margin: 0 -16px 16px;
    table-layout: fixed;
    flex-basis: 100%;

    /* Prevent the wrapper spacing from breaking the selection area */
    /* Paired with the line 105 "pointer-events: auto;" */
    pointer-events: none;

    /*
     * This position was added to prevent the ::before from the "TableCellSticky"
     * to fill the other space of other components. Example the "FirstSteps" from being seen
     */
    position: relative;

    ${TableComponents.TableCellSticky} {
      /* AvatarStack has a z-index of 2 to actually show the stacked
      logos, so we need to do this to prevent the avatar go over the sticky cell */
      z-index: 2; /* stylelint-disable-line scales/z-indices */
      right: 0;
    }

    ${breakpoint('sm')`
    margin: 0 -40px 40px;
  `}

    /* Compensate for the Margin and make the table scroll without blank sides */
    ${TableComponents.Table} {
      padding-left: 16px;
      border-spacing: 0px 1px;

      ${breakpoint('sm')`
        padding: 0 40px;
      `}
    }

    ${TableComponents.TableHeaderCell} {
      &:nth-child(1),
      &:nth-child(4) {
        width: 30%;
      }

      &:nth-child(2),
      &:nth-child(3) {
        width: 20%;
      }
    }

    ${TableComponents.TableRow} {
      cursor: pointer;

      /* Re-enable pointer events for the table */
      /* Paired with the line 60 "pointer-events: none;" */
      pointer-events: auto;

      #root.no-select & {
        pointer-events: none;
      }
    }

    ${TableComponents.TableRow} td:last-child {
      text-align: right;
      width: 60px;

      ${breakpoint('lg')`
        width: 60px;
      `}
    }

    ${breakpoint('base', 'sm')`
    overflow: auto;
    width: calc(100% + 16px);

    ${TableComponents.TableHeaderCell}:not(:last-child) {
      min-width: 200px;
    }

    ${TableComponents.TableHeaderCell}:last-child {
      top: 0;
      right: 0;
      width: 60px;

      ${breakpoint('base', 'sm')`
        color: ${theme.colors.background.secondary.A}; /** Just for hiding the text */
      `}
    }
  `}
  `
)

export const FocusLink = styled(Link)`
  display: block; /* Needed to avoid cutting focus ring when using a keyboard */

  &:focus ${DocumentGridItem} {
    ${GridFocusStyles};
  }
`

export const Footer = styled(BaseFooter)`
  margin-top: auto;
`
